import React, { useState, useEffect, useMemo } from "react";

import { getAllSites } from "app/_services/ehs/ehsSiteServices";
import { UserService } from "app/_services/UserService/UserService";
import { getAuthUser, LOGGED_IN_USER_SITE_ID } from "../../IncidentManagement/Helper";
import { userDropdownLabel } from "app/_helpers/helper";
import moment from "moment";
import FilterForm from "app/Components/FilterForm/FilterForm";
import { ohseFilterFields } from "../CONSTANT";
import { getAllEvents } from "app/_services/ehs/ehsEventServices";

export default function OHSEFilter({ form, onChange, onReset, setForm }) {
  const [state, setState] = useState({
    sites: [],
  });

  const [userList, setUserList] = useState([]);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    UserService.getUsers("filter[status]=1").then((response) => {
      if (!response?.data) return;
      const userSiteId = LOGGED_IN_USER_SITE_ID();
      const auth_user = getAuthUser();

      setUserList(
        response.data
          .filter(
            (user) =>
              +auth_user?.role?.roleLable === 1 ||
              +user?.employee?.ehsSite?.id === userSiteId
          )
          .map((user) => ({
            label: userDropdownLabel(user),
            id: user.id,
            value: user.id,
          }))
      );
    });

    getAllSites("filter[status]=1").then((response) => {
      if (!response?.data) return;

      setState((prev) => ({
        ...prev,
        //initialActivity: response?.data,
        sites: response.data.map((row) => ({ label: row.name, value: row.id })),
        roSites: response.data
          .filter((d) => d.siteType === 2)
          .map((row) => ({ label: row.name, value: row.id })),
      }));
    });

    getAllEvents("filter[status]=1").then((response) => {
      if (!response?.data) return;
      setEvents(() => {
        return response?.data?.map((d) => {
          return { name: d.name, value: d.id };
        });
      });
    });
  }, []);

  const fields = useMemo(
    () =>
      ohseFilterFields.map((f) => {
        const field = { ...f };

        switch (field.name) {
          case "eventId":
            field.options = events;
            break;
          case "approvedBy":
            field.options = userList;
            break;
          case "siteId":
            field.options = state.sites;
            break;
          case "reviewedBy":
            field.options = userList;
            break;
          case "ownerId":
            field.options = userList;
            break;

          default:
            break;
        }

        return field;
      }),
    [events, userList, state.sites]
  );

  const handleDateRange = (dates) => {
    console.log("dates", dates);
    onChange({
      target: {
        name: "startDate",
        value: dates.startDate
          ? moment(new Date(dates.startDate)).format("YYYY-MM-DD")
          : null,
      },
    });
    onChange({
      target: {
        name: "endDate",
        value: dates.endDate
          ? moment(new Date(dates.endDate)).format("YYYY-MM-DD")
          : null,
      },
    });
  };
  return (
    <div className="pb-4">
      <FilterForm
        fields={fields}
        form={form}
        onChange={onChange}
        onReset={onReset}
        handleDateRange={handleDateRange}
        startDate={form?.startDate || null}
        endDate={form?.endDate || null}
      />
    </div>
  );
}
